import { Card, Flex, Skeleton, Typography } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { border, neutral, radius, shadow, spacing, typography } from "../../theme/tokens";

const { Text } = Typography;

/**
 * Thẻ số của dải mini-dashboard trên các màn danh sách.
 *
 * Bố cục NGANG (icon | nhãn + số) thay vì dọc: bản dọc cũ cao gần gấp đôi vì nhãn,
 * icon và số nằm trên ba hàng, chiếm hết một màn hình dọc trước khi thấy được bảng.
 * Cùng một hình dạng với `PageLayout/MetricCard` để dải thẻ ở mọi màn cao bằng nhau.
 *
 * Vẫn nhận nguyên `stat` cũ nên các màn đang dùng không phải sửa gì:
 *   { title, value, icon, color, prefix?, suffix?, trend?, path?, bgColor?, borderColor? }
 */
const StatCard = ({ stat, loading }) => {
  const accent = stat.color || neutral[500];

  const content = (
    <Flex align="center" gap={spacing[4]}>
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: radius.md,
          fontSize: typography.size.xl,
          background: `${accent}18`,
          color: accent,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {stat.icon}
      </div>

      <div style={{ minWidth: 0 }}>
        <Text
          style={{
            display: "block",
            color: neutral[500],
            fontSize: typography.size.sm,
            fontWeight: typography.weight.medium,
            lineHeight: 1.3,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {stat.title}
        </Text>

        <Flex align="baseline" gap={spacing[2]}>
          <span
            style={{
              fontSize: typography.size["2xl"],
              fontWeight: typography.weight.bold,
              lineHeight: 1.2,
              color: neutral[900],
            }}
          >
            {stat.prefix}
            {stat.value}
            {stat.suffix}
          </span>

          {stat.trend && (
            <Text
              type={stat.trend.isUp ? "success" : "danger"}
              style={{ fontSize: typography.size.sm, fontWeight: typography.weight.semibold }}
            >
              {stat.trend.isUp ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
              {stat.trend.value}%
            </Text>
          )}
        </Flex>
      </div>
    </Flex>
  );

  return (
    <Card
      bordered={false}
      hoverable={Boolean(stat.path)}
      style={{
        borderRadius: radius.md,
        boxShadow: shadow.xs,
        border: stat.bgColor ? `1px solid ${stat.borderColor || accent}` : border.hairline,
        background: stat.bgColor || "#fff",
        height: "100%",
      }}
      styles={{ body: { padding: `${spacing[4]}px ${spacing[5]}px` } }}
    >
      {loading ? (
        <Skeleton active paragraph={false} title={{ width: "70%" }} style={{ margin: 0 }} />
      ) : stat.path ? (
        <Link to={stat.path}>{content}</Link>
      ) : (
        content
      )}
    </Card>
  );
};

export default StatCard;
